import * as constants from './constants'
import * as ReducerHelper from '@eig-builder/core-utils/helpers/reducer-helper'

const initialState = {
  getDomainsByAccountRetrieving: false
}

const reducer = (state = initialState, action) => {
  const listenState = ReducerHelper.listenToFetchActions(state, action, constants.GET_DOMAINS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_REGISTERED_DOMAINS_BY_ACCOUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_LINKED_DOMAINS_BY_ACCOUNT) ||
    state

  if (listenState) {
    return listenState
  }
}

export default reducer
